import ApiService from './api-service'

class Content extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        this.put = null
        // this.delete = null
    }

    list(options) {
      return super.get('/content', options)
    }


    clear(id) {
      if(id) return super.clear(`/content/${id}`)
      return super.clear('/content')
    }


    get(id, options) {
      return super.get(`content/${id}`, options)
    }

    getShareSnapshot(id, options) {
      return super.get(`/content/webshare/${id}/snapshot`, options)
    }

    create(payload, options) {
      return super.post(`content`, payload, options)
    }

    update(id, payload, options) {
      return super.put(`content/${id}`, payload, options)
    }

    duplicate(id, payload, options) {
      return super.post(`content/${id}/duplicate`, payload, options)
    }

    transfer(id, payload, options) {
      return super.post(`content/${id}/transfer`, payload, options)
    }

    delete(id, options) {
      return super.delete(`content/${id}`, options)
    }

    getResponse(id, questionId, groupId, options) {
      const url = `content/${id}/${questionId ? `question/${questionId}/` : ``}${questionId && groupId ? `group/${groupId}/` : ``}response`
      // return super.get(url, options)
      return new Promise((res, reject) => reject());
    }

    saveResponse(id, questionId, groupId, payload, options) {
      // return super.post(`content/${id}/question/${questionId}/${groupId ? `group/${groupId}/` : ``}response`, payload, options)
      return new Promise((res) => res({}));
    }

    getGroupResponses(id, questionId, groupId, options) {
      const url = `content/${id}/question/${questionId}/group/${groupId}/responses`
      return super.get(url, options)
    }

    getShares(id, options) {
      return super.get(`content/${id}/share`, options)
    }

    createShares(id, payload, options) {
      return super.post(`content/${id}/share`, payload, options)
    }

    deleteShares(id, payload, options) {
      return super.post(`content/${id}/unshare`, payload, options)
    }

    publishToShares(id, options) {
      return super.post(`/content/${id}/share/publish`, {}, options)
    }

    async visability(id, options = {}) {
      options.ignoreCache = true
      return super.get(`content/${id}/visability`, options)
    }

    hide(id, options) {
      return super.post(`content/${id}/hide`, {}, options)
    }

    unhide(id, options) {
      return super.post(`content/${id}/unhide`, {}, options)
    }
    restore = this.unhide

    report(id, payload, options) {
      return super.post(`content/${id}/report`, payload, options)
    }

    pinShare(id, params = {}, options) {
      return super.post(`content/share/${id}/pin`, params, options)
    }

    unpinShare(id, params = {}, options) {
      return super.post(`content/share/${id}/unpin`, params, options)
    }

    favouriteShare(id, params = {}, options) {
      return super.post(`content/share/${id}/favourite/add`, params, options)
    }

    unfavouriteShare(id, params = {}, options) {
      return super.post(`content/share/${id}/favourite/remove`, params, options)
    }

    statShareOpen(ids = [], options) {
      return super.post(`content/share/stat/open`, {ids}, options)
    }

    statShareView(ids = [], options) {
      return super.post(`content/share/stat/view`, {ids}, options)
    }

    exportPDF(contentId, contentShareId, params = {}, options) {
      return super.post(contentShareId ? `content/share/${contentShareId}/export` : `content/${contentId}/export`, params, options)
    }

    checkExportPDF(contentId, contentShareId, options) {
      return super.get(contentShareId ? `content/share/${contentShareId}/export/check` : `content/${contentId}/export/check`, options)
    }
}

const _Content = new Content()
export default _Content
